<h1 mat-dialog-title>Attenzione</h1>

<div mat-dialog-content>
  <p class="text-center">
    L'operazione che stai per eseguire potrebbe richiedere qualche minuto. <br />
    Sei sicuro di voler proseguire?
  </p>
</div>

<div mat-dialog-actions class="d-flex space-between">
  <button mat-raised-button color="warn" [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
    Annulla
  </button>

  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    Prosegui
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
